// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item {
  --padding-start: 0px;
  border: 1px solid black;
}

ion-datetime {
  max-width: 100%;
}

ion-grid {
  margin: 15px 20px;
}

@media (orientation: landscape) {
  ion-content {
    --padding-start: calc(var(--sar, 0px) / 1.5);
    --padding-end: calc(var(--sal, 0px) / 1.5);
  }
}
ion-content::part(scroll) {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.bottom-w2g-text {
  display: flex;
  align-items: flex-end;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/tax-reports/tax-reports.component.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,uBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAGE;EADF;IAEI,4CAAA;IACA,0CAAA;EACF;AACF;AACE;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;AACJ;;AAGA;EACE,aAAA;EACA,qBAAA;AAAF","sourcesContent":["ion-item {\r\n  --padding-start: 0px;\r\n  border: 1px solid black;\r\n}\r\n\r\nion-datetime {\r\n  max-width: 100%;\r\n}\r\n\r\nion-grid {\r\n  margin: 15px 20px;\r\n}\r\n\r\nion-content {\r\n  @media (orientation: landscape) {\r\n    --padding-start: calc(var(--sar, 0px) / 1.5);\r\n    --padding-end: calc(var(--sal, 0px) / 1.5);\r\n  }\r\n\r\n  &::part(scroll) {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-between;\r\n  }\r\n}\r\n\r\n.bottom-w2g-text {\r\n  display: flex;\r\n  align-items: flex-end;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
